import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {PagesComponent} from './pages.component';
import {RouterModule} from '@angular/router';
import {PagesRoutingModule} from './pages-routing.module';
import {ReactiveFormsModule} from '@angular/forms';
import {FaIconComponent, FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {
  NgbAccordionModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbTypeaheadModule
} from "@ng-bootstrap/ng-bootstrap";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {TranslateModule, TranslatePipe} from "@ngx-translate/core";
import {TicketTableComponent} from './antrag-ticket/ticket-table/ticket-table.component';
import {DefaultLayoutComponent} from "../shared/default-layout/default-layout.component";
import {SchuelerTableComponent} from './schueler/schueler-table/schueler-table.component';
import {SchuelerDetailComponent} from './schueler/schueler-detail/schueler-detail.component';
import {CheckboxMultipleComponent} from "../shared/form/checkbox-multiple/checkbox-multiple.component";
import {CustomRadioComponent} from "../shared/form/custom-radio/custom-radio.component";
import {SafeHtmlPipe} from "../shared/pipes/safe-html.pipe";
import {InputComponent} from "../shared/form/input/input.component";
import {SelectComponent} from "../shared/form/select/select.component";
import {TextareaComponent} from "../shared/form/textarea/textarea.component";
import {NgSelectModule} from '@ng-select/ng-select';
import {PictureFileComponent} from './picture-file/picture-file/picture-file.component';
import {TicketDetailSbTrueComponent} from "./antrag-ticket/ticket-detail-sb-true/ticket-detail-sb-true.component";
import {TicketDetailParentComponent} from "./antrag-ticket/ticket-detail-parent/ticket-detail-parent.component";
import {FahrkostenTableComponent} from "./fahrkosten/fahrkosten-table/fahrkosten-table.component";
import {
  FahrkostenDetailParentComponent
} from "./fahrkosten/fahrkosten-detail-parent/fahrkosten-detail-parent.component";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {
  FahrkostenDetailSbTrueComponent
} from './fahrkosten/fahrkosten-detail-sb-true/fahrkosten-detail-sb-true.component';
import {FahrkostenUniversalComponent} from './fahrkosten/fahrkosten-universal/fahrkosten-universal.component';
import {FahrkostenBelegeComponent} from './fahrkosten/fahrkosten-belege/fahrkosten-belege.component';
import {HomeComponent} from './home/home.component';
import {NgxSpinnerModule} from "ngx-spinner";
import {GermanDecimalDirective} from "../shared/form/german-decimal/german-decimal.directive";
import {
  GermanDecimalAnydigitsComponent
} from "../shared/form/german-decimal/german-decimal-anydigits/german-decimal-anydigits.component";
import {ProfilComponent} from './profil/profil.component';
import {AccountComponent} from "./account/account.component";
import {
  AttachmentTypeAdjustComponent
} from "./antrag-ticket/ticket-detail-sb-true/sidebar/attachment-type-adjust/attachment-type-adjust.component";
import {
  TicketAntragAttachmentUploadComponent
} from "./antrag-ticket/ticket-detail-sb-true/sidebar/attachment-upload/ticket-antrag-attachment-upload.component";
import {
  TicketDetailSidebarComponent
} from "./antrag-ticket/ticket-detail-sb-true/sidebar/sidebar-component/ticket-detail-sidebar.component";
import {
  TicketAntragSidebarAttachmentsComponent
} from "./antrag-ticket/ticket-detail-sb-true/sidebar/ticket-antrag-sidebar-attachments/ticket-antrag-sidebar-attachments.component";
import {
  SonderfallMultiSelectComponent
} from "./antrag-ticket/ticket-detail-sb-true/sonderfall-multi-select/sonderfall-multi-select.component";
import {StudentTicketListComponent} from "./ticket/ticket-list/student-ticket-list.component";
import {StudentTicketCardComponent} from "./ticket/ticket-card/student-ticket-card.component";
import {TicketCardDetailsComponent} from "./ticket/ticket-card-details/ticket-card-details.component";
import {TicketPaymentDetailsComponent} from "./ticket/ticket-payment-details/ticket-payment-details.component";
import {
  TicketTerminationDetailsComponent
} from "./ticket/ticket-termination-details/ticket-termination-details.component";
import {
  TerminationFormModalComponent
} from "./ticket/termination/termination-form-modal/termination-form-modal.component";
import {PaginationComponent} from "../shared/pagination/pagination.component";
import {TrafficLightMiniComponent} from "../shared/traffic-light/traffic-light-mini/traffic-light-mini.component";
import {TrafficLightComponent} from "../shared/traffic-light/traffic-light/traffic-light.component";
import {
  AntragstellerCardComponent
} from "./antrag-ticket/ticket-detail-sb-true/antragsteller-card/antragsteller-card.component";
import {CheckboxComponent} from "../shared/form/checkbox/checkbox.component";
import {LandPipe} from "../shared/pipes/land.pipe";
import {SchoolInfoComponent} from "./antrag-ticket/ticket-detail-sb-true/school-info/school-info.component";
import {StudentTicketAttachmentsComponent} from "./ticket/ticket-attachments/student-ticket-attachments.component";

@NgModule({
	declarations: [
		PagesComponent,
    TicketTableComponent,
    TicketDetailParentComponent,
    TicketDetailSbTrueComponent,
    TicketDetailSidebarComponent,
    TicketAntragAttachmentUploadComponent,
    AttachmentTypeAdjustComponent,
    FahrkostenTableComponent,
    FahrkostenDetailParentComponent,
    DefaultLayoutComponent,
    SchuelerTableComponent,
    SchuelerDetailComponent,
    CheckboxMultipleComponent,
    CustomRadioComponent,
    PictureFileComponent,
    FahrkostenDetailSbTrueComponent,
    FahrkostenUniversalComponent,
    FahrkostenBelegeComponent,
    HomeComponent,
    GermanDecimalDirective,
    GermanDecimalAnydigitsComponent,
    ProfilComponent,
    AccountComponent,
    StudentTicketListComponent,
    StudentTicketCardComponent,
    PaginationComponent,
    TerminationFormModalComponent,
    TicketCardDetailsComponent,
    TicketTerminationDetailsComponent,
    TicketPaymentDetailsComponent
	],
  imports: [
    CommonModule,
    RouterModule,
    PagesRoutingModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    TranslateModule,
    NgbDropdownModule,
    NgxDatatableModule,
    NgbTypeaheadModule,
    NgSelectModule,
    NgbDatepickerModule,
    PdfViewerModule,
    NgxSpinnerModule,
    NgbAccordionModule,
    TrafficLightComponent,
    TrafficLightMiniComponent,
    InputComponent,
    AntragstellerCardComponent,
    SelectComponent,
    CheckboxComponent,
    LandPipe,
    SchoolInfoComponent,
    FaIconComponent,
    TranslatePipe,
    DatePipe,
    SafeHtmlPipe,
    TextareaComponent,
    TicketAntragSidebarAttachmentsComponent,
    SonderfallMultiSelectComponent,
    StudentTicketAttachmentsComponent
  ],
  exports: [
    DefaultLayoutComponent,
    SelectComponent,
    CheckboxMultipleComponent,
    TextareaComponent,
    GermanDecimalAnydigitsComponent,
    GermanDecimalDirective
  ],
  bootstrap: []
})
export class PagesModule {}
